export const HERO_VIDEO_URL = "/videos/video-face-smooth.mp4";
export const HERO_VIDEO_URL_MOBILE = "/videos/video-face-mobile-smooth.mp4";

export const BRAND = {
  name: "Francisco Padilla",
  channel: "SOYPACOIA",
};

export const NAV_LINKS = [
  { label: "Servicios", href: "#servicios" },
  { label: "Sobre mí", href: "#sobre" },
  { label: "Comunidad", href: "#comunidad" },
  { label: "Contacto", href: "#contacto" },
];

export const HERO_STAGES = [
  {
    eyebrow: "Educador & Consultor IA",
    title: "IA que transforma",
    accent: "negocios reales.",
    body: "Aprende, automatiza y construye con inteligencia artificial sin necesitar ser técnico.",
    cta: true,
  },
  {
    eyebrow: "Comunidad IA",
    title: "Más de 3,000",
    accent: "profesionales.",
    body: "LATAM · Hispanoamérica · Construyendo con IA desde hoy.",
    cta: false,
  },
  {
    eyebrow: "Framework SALVA",
    title: "IA práctica para",
    accent: "la vida real.",
    body: "Sitúate · Aprende · Libérate · Vuélvete Indispensable · Actúa.",
    cta: false,
  },
];

export const HERO_SIDEBAR = [
  { type: "label", text: "Currently" },
  { type: "hero", text: "Construyendo agentes IA" },
  { type: "body", text: "para clínicas y despachos legales en LATAM" },
  { type: "spacer" },
  { type: "label", text: "This Week" },
  {
    type: "link",
    text: "01  ChatGPT Hizo Toda Mi Mañana de Trabajo… Con Mi Voz",
    url: "https://www.youtube.com/watch?v=KWmGO69Qhig",
  },
  {
    type: "link",
    text: "02  Gemini Spark para Automatizar mi Negocio",
    url: "https://www.youtube.com/watch?v=-R04RkoiH1c",
  },
  {
    type: "link",
    text: "03  ¡NUEVO Gemini NotebookLM es una LOCURA!",
    url: "https://www.youtube.com/watch?v=kFgCQeVEHi4",
  },
  { type: "spacer" },
  { type: "label", text: "Follow" },
  { type: "link", text: "YouTube", url: "https://youtube.com/@soypacoia" },
  { type: "link", text: "TikTok", url: "https://tiktok.com/@soypacoia" },
  { type: "link", text: "Facebook", url: "https://facebook.com/soypacoia" },
  { type: "link", text: "Instagram", url: "https://instagram.com/soypacoia" },
];

export const COMMAND_CHIPS = [
  { label: "Automatizar mi trabajo", query: "Automatizar mi trabajo con IA" },
  { label: "Contenido para YouTube", query: "Crear contenido para YouTube con IA" },
  { label: "Crear agente de IA", query: "Crear un agente de IA para mi negocio" },
  { label: "Aprender ChatGPT", query: "Aprender ChatGPT desde cero" },
  { label: "Vender servicios IA", query: "Vender servicios de inteligencia artificial" },
  { label: "IA en mi negocio", query: "Implementar IA en mi clínica o negocio" },
];

export const PRODUCTS = [
  {
    tag: "Asistente WhatsApp",
    name: "Lorena",
    desc: "Lorena es la empleada digital que atiende el WhatsApp de tu negocio, contesta en segundos, agenda las citas en tu calendario de Google y cuida tu agenda mientras tú cenas, atiendes o duermes.",
    cta: "Probar",
    href: "https://lorena.soypacoia.com/",
    external: true,
  },
  {
    tag: "Generador Visual",
    name: "Creative Content Engine",
    desc: "Genera imágenes y copy para tus redes. Multiplica tu producción 10x.",
    cta: "Obtener",
    href: "https://payhip.com/b/7iCsF",
    external: true,
  },
  {
    tag: "Generador de Ads",
    name: "ADS Generator",
    desc: "Genera hasta 64 ads profesionales con IA en minutos.",
    cta: "Obtener",
    href: "https://payhip.com/b/RtVmL",
    external: true,
  },
  {
    tag: "Lead Generation",
    name: "Fábrica de Leads IA",
    desc: "Google Places + IA. Exporta listas de prospectos a tu Drive.",
    cta: "Obtener",
    href: "https://payhip.com/b/MYWdL",
    external: true,
  },
  {
    tag: "Comunidad",
    name: "Comunidad IA",
    desc: "15K+ profesionales LATAM construyendo con IA. Recursos, tutoriales y acceso anticipado.",
    cta: "Unirse",
    href: "https://youtube.com/@soypacoia",
    external: true,
  },
];

export const SALVA = [
  { letter: "S", name: "Sitúate", desc: "Entiende dónde estás en la era IA" },
  { letter: "A", name: "Aprende lo Justo", desc: "Sin cursos eternos, solo lo necesario" },
  { letter: "L", name: "Libérate", desc: "Automatiza lo repetitivo" },
  { letter: "V", name: "Vuélvete Indispensable", desc: "Sé el que sabe usar IA en tu equipo" },
  { letter: "A", name: "Actúa y Adapta", desc: "Itera, construye, mejora cada semana" },
];

export const TYPEWRITER_PHRASES = [
  "Quiero automatizar mi negocio...",
  "Quiero crear un agente de IA...",
  "Quiero hacer crecer mi canal...",
  "Quiero aprender ChatGPT...",
  "Quiero vender servicios de IA...",
];
